import React, { ReactElement, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { Image } from 'components/lib';
import { LogoIcon } from 'components/icons';
import { colorLightBlue } from 'customColors';

interface LeadershipPositionCardProps {
  organization: string;
  position: string;
  startDate: string;
  endDate: string;
  location?: string;
  logoUrl?: string;
}

export const LeadershipPositionCard = ({
  organization,
  position,
  startDate,
  endDate,
  location,
  logoUrl,
}: LeadershipPositionCardProps): ReactElement => {
  const [logoFailedToLoad, setLogoFailedToLoad] = useState(false);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: '12px',
        padding: '16px',
        backgroundColor: 'transparent',
        borderRadius: 0,
        border: '1px solid #E8E8E8',
      }}
    >
      <Box
        sx={{
          width: '48px',
          height: '48px',
          borderRadius: '8px',
          backgroundColor: colorLightBlue,
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
        }}
      >
        {logoUrl && !logoFailedToLoad ? (
          <Image
            src={logoUrl}
            alt={organization}
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            onError={() => setLogoFailedToLoad(true)}
          />
        ) : (
          <LogoIcon fontSize="24px" />
        )}
      </Box>
      <Box flex={1}>
        <Typography
          sx={{
            fontSize: '16px',
            fontWeight: 600,
            color: '#1F1F1F',
            marginBottom: '4px',
          }}
        >
          {organization}
        </Typography>
        <Typography
          sx={{
            fontSize: '14px',
            fontWeight: 500,
            color: '#1F1F1F',
            marginBottom: '8px',
          }}
        >
          {position}
        </Typography>
        <Typography
          sx={{
            fontSize: '12px',
            color: '#6B6B6B',
          }}
        >
          {startDate} - {endDate}
        </Typography>
        {location && (
          <Typography
            sx={{
              fontSize: '12px',
              color: '#6B6B6B',
            }}
          >
            {location}
          </Typography>
        )}
      </Box>
    </Box>
  );
};
